module.exports = "<div class=\"widgets\">\n\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <ba-card cardTitle=\"Population group list\" baCardClass=\"with-scroll\">\n        <population-group-list></population-group-list>\n      </ba-card>\n    </div>\n\n    <div class=\"col-md-4\">\n      <ba-card cardTitle=\"Population group form\" baCardClass=\"with-scroll\">\n        <population-group-form></population-group-form>\n      </ba-card>\n    </div>\n\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/localization/components/population-group/population-group.component.html
// module id = 865
// module chunks = 8